<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit Notifications
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Customer Id *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <api-data-source   api-path="components_data/customer_id_option_list" >
                                                                        <template v-slot="req">
                                                                            <Dropdown class="w-full" :class="getErrorClass('customer_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlcustomer_id"  v-model="formData.customer_id" :options="req.response" label="Customer Id"  placeholder="Select a value ..." >
                                                                            </Dropdown> 
                                                                            <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                                        </template>
                                                                    </api-data-source>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Notification Type *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlnotification_type" v-model.trim="formData.notification_type"  label="Notification Type" type="text" placeholder="Enter Notification Type"      
                                                                    class=" w-full" :class="getErrorClass('notification_type')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('notification_type')" class="p-error">{{ getFieldError('notification_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Message 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('message')" class="w-full" ref="ctrlmessage" rows="5"  v-model="formData.message" placeholder="Enter Message"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('message')" class="p-error">{{ getFieldError('message') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Channel 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlchannel" v-model.trim="formData.channel"  label="Channel" type="text" placeholder="Enter Channel"      
                                                                    class=" w-full" :class="getErrorClass('channel')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('channel')" class="p-error">{{ getFieldError('channel') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Status *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlstatus" v-model.trim="formData.status"  label="Status" type="text" placeholder="Enter Status"      
                                                                    class=" w-full" :class="getErrorClass('status')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('status')" class="p-error">{{ getFieldError('status') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" label="Update" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'notifications',
		},
		routeName: {
			type: String,
			default: 'notificationsedit',
		},
		pagePath: {
			type : String,
			default : 'notifications/edit',
		},
		apiPath: {
			type: String,
			default: 'notifications/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		customer_id: "", 
		notification_type: "general", 
		message: "", 
		channel: "push", 
		status: "unread", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/notifications`);
	}
	const rules = computed(() => {
		return {
			customer_id: { required, numeric },
			notification_type: { required },
			message: {  },
			channel: {  },
			status: { required }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit Notifications";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
